export default __webpack_public_path__ + "static/media/person.5e1df460.svg";